import { Button2 } from "@/ui2/atoms/Button";
import EmptyStateIcon from "@/assets/images/icons2/icon--empty-state.svg?component";
import { Heading2 } from "@/ui2/atoms/Heading";

type EmptyTableProps = {
  ctaProps?: {
    label: string;
    onPress: VoidFunction;
  };
  message: string;
};

export function EmptyTable({ ctaProps, message }: EmptyTableProps) {
  const { label, onPress } = ctaProps || {};

  return (
    <div className="tw:mx-auto tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:py-28.5">
      <EmptyStateIcon />

      <Heading2 as="h3" className="tw:text-text-tertiary" size={2}>
        {message}
      </Heading2>

      <Button2
        className={!ctaProps ? "tw:invisible" : undefined}
        onPress={onPress ?? (() => {})}
        variant="secondary"
      >
        {label}
      </Button2>
    </div>
  );
}
